import React from 'react';
export function SmsTerms() {
  return <div className="py-16 px-4 max-w-4xl mx-auto w-full" data-id="element-371">
      <div className="mb-12 border-b border-neutral-800 pb-8" data-id="element-372">
        <h1 className="font-display text-5xl tracking-wide mb-4" data-id="element-373">
          VSC Clothing SMS Terms & Conditions
        </h1>
        <p className="text-neutral-300 font-medium" data-id="element-374">
          VSCCLOTHING d/b/a VSC Clothing
        </p>
        <p className="text-neutral-400 mt-1" data-id="element-375">
          312 S 4th Street Downtown, Louisville, KY 40202
        </p>
      </div>

      <div className="prose prose-invert prose-neutral max-w-none space-y-8" data-id="element-376">
        <section data-id="element-377">
          <h2 className="text-2xl font-medium text-white mb-4" data-id="element-378">Program Name</h2>
          <p className="text-neutral-300 leading-relaxed" data-id="element-379">
            VSC Clothing SMS Alerts
          </p>
        </section>

        <section data-id="element-380">
          <h2 className="text-2xl font-medium text-white mb-4" data-id="element-381">
            Program Description
          </h2>
          <p className="text-neutral-300 leading-relaxed" data-id="element-382">
            Messages sent to customers and prospects who opt in via the web form
            at vscclothing.com.
          </p>
        </section>

        <section data-id="element-383">
          <h2 className="text-2xl font-medium text-white mb-4" data-id="element-384">
            Eligible Recipients
          </h2>
          <p className="text-neutral-300 leading-relaxed" data-id="element-385">
            Customers and prospects who submit the opt-in form at
            vscclothing.com.
          </p>
        </section>

        <section data-id="element-386">
          <h2 className="text-2xl font-medium text-white mb-4" data-id="element-387">
            Message Types
          </h2>
          <p className="text-neutral-300 leading-relaxed" data-id="element-388">
            Order confirmations, shipping updates, new drop announcements,
            promotional offers, account alerts.
          </p>
        </section>

        <section data-id="element-389">
          <h2 className="text-2xl font-medium text-white mb-4" data-id="element-390">
            Opt-In Method
          </h2>
          <p className="text-neutral-300 leading-relaxed" data-id="element-391">
            Web form at vscclothing.com with explicit disclosure above the
            submit button.
          </p>
        </section>

        <section data-id="element-392">
          <h2 className="text-2xl font-medium text-white mb-4" data-id="element-393">
            Message Frequency
          </h2>
          <p className="text-neutral-300 leading-relaxed" data-id="element-394">
            Varies based on order activity and promotional calendar.
          </p>
        </section>

        <section data-id="element-395">
          <h2 className="text-2xl font-medium text-white mb-4" data-id="element-396">Opt-Out</h2>
          <p className="text-neutral-300 leading-relaxed" data-id="element-397">
            Reply STOP to cancel. One confirmation message will be sent. No
            further messages after that.
          </p>
        </section>

        <section data-id="element-398">
          <h2 className="text-2xl font-medium text-white mb-4" data-id="element-399">Help</h2>
          <p className="text-neutral-300 leading-relaxed" data-id="element-400">
            Reply HELP. Or contact us at{' '}
            <a href="mailto:vscclothing5@gmail.com" className="underline hover:text-white" data-id="element-401">
              vscclothing5@gmail.com
            </a>{' '}
            or 312 S 4th Street Downtown, Louisville, KY 40202.
          </p>
        </section>

        <section data-id="element-402">
          <h2 className="text-2xl font-medium text-white mb-4" data-id="element-403">Cost</h2>
          <p className="text-neutral-300 leading-relaxed" data-id="element-404">
            Message and data rates may apply.
          </p>
        </section>

        <section data-id="element-405">
          <h2 className="text-2xl font-medium text-white mb-4" data-id="element-406">
            Carrier Disclaimer
          </h2>
          <p className="text-neutral-300 leading-relaxed" data-id="element-407">
            Carriers are not liable for delayed or undelivered messages.
          </p>
        </section>

        <section data-id="element-408">
          <h2 className="text-2xl font-medium text-white mb-4" data-id="element-409">No Sharing</h2>
          <p className="text-neutral-300 leading-relaxed font-semibold text-vsc-gold" data-id="element-410">
            Phone numbers and SMS consent will not be sold, rented, or shared
            with third parties for marketing.
          </p>
        </section>
      </div>
    </div>;
}